(function () {
  var preloader = document.getElementById('site-preloader');
  if (!preloader) return;

  // Hard cap so a load event that never fires (a hung request, a flaky
  // third-party script) can't leave the overlay stuck over the store
  // forever -- it always gets out of the way eventually.
  var MAX_WAIT_MS = 6000;

  var minDuration = parseInt(preloader.dataset.minDuration, 10) || 0;
  var start = Date.now();
  var hidden = false;

  function hide() {
    if (hidden) return;
    hidden = true;
    preloader.classList.add('site-preloader--hidden');
    preloader.addEventListener(
      'transitionend',
      function () {
        preloader.remove();
      },
      { once: true }
    );
  }

  function onReady() {
    var elapsed = Date.now() - start;
    var remaining = Math.max(0, minDuration - elapsed);
    setTimeout(hide, remaining);
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    window.addEventListener('load', onReady);
  }

  setTimeout(hide, MAX_WAIT_MS);
})();
